import { render, staticRenderFns } from "./AnimalRxWidget.vue?vue&type=template&id=71d8437b"
import script from "./AnimalRxWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnimalRxWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AnimalRxWidget.vue?vue&type=style&index=0&id=71d8437b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports